import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ContentLayout from '@/layouts/content-layout'
import ProgramFormView from '@/sections/programs/view/program-form-view'

export default function ProgramFormPage() {
  const location = useLocation()

  // Determine title based on pathname
  const title = useMemo(() => {
    if (location.pathname.includes('/programs/create')) {
      return 'เพิ่มโปรแกรม'
    }
    if (location.pathname.match(/^\/programs\/[^/]+\/edit/)) {
      return 'แก้ไขโปรแกรม'
    }
    return 'โปรแกรม'
  }, [location.pathname])

  return (
    <ContentLayout title={title} backButton>
      <ProgramFormView />
    </ContentLayout>
  )
}
